import Vuex from 'vuex'
import Vue from 'vue'
import * as types from './types'
import tab from './modules/tab'
import permission from './modules/permission'
import http from '../http'
import {api} from '@/api/api'

Vue.use(Vuex)

const LOCAL_STORAGE_KEY_SESSION_ID = 'sessionId'
const LOCAL_STORAGE_KEY_PERMISSION_LIST = 'permissionList'
const LOCAL_STORAGE_KEY_COMPANY_ID = 'companyId'
const LOCAL_STORAGE_KEY_CONTROL_ID = 'controlId'
const LOCAL_STORAGE_KEY_ROLE = 'role'
const LOCAL_STORAGE_KEY_RISKLEVEL = 'riskLevel'
const LOCAL_STORAGE_KEY_EDITTIME = 'editTime'
const LOCAL_STORAGE_KEY_SYSURL = 'sysUrl'
const LOCAL_STORAGE_DEPARTMENT_OPTIONS = 'departmentOptions'
const InitUserInfo = {
  roles: []
}
const SEARCHFORM = {
  is_fire_safety_focus: null,
  is_safety_insurance: null,
  safety_standard_A: null,
  safety_standard_B: null,
  safety_standard_C: null,
  name: null,
  control_id: null,
  area_id: null,
  risk_level: null,
  check_status: null,
  area_id: null,
  town: null,
  info_status: null,
  source_type: null,
  dynamic_risk_level: null,
  dynamic_info_status: null,
  department_area_id: 0,
  department_type_id: null
}

export default new Vuex.Store({
  state: {
    cityId: 3505,
    sessionId: localStorage.getItem(LOCAL_STORAGE_KEY_SESSION_ID),
    userInfo: InitUserInfo,
    permissionList: localStorage.getItem(LOCAL_STORAGE_KEY_PERMISSION_LIST),
    companyId: localStorage.getItem(LOCAL_STORAGE_KEY_COMPANY_ID),
    controlId: localStorage.getItem(LOCAL_STORAGE_KEY_CONTROL_ID),
    role: localStorage.getItem(LOCAL_STORAGE_KEY_ROLE),
    riskLevel: localStorage.getItem(LOCAL_STORAGE_KEY_RISKLEVEL),
    editTime: localStorage.getItem(LOCAL_STORAGE_KEY_EDITTIME),
    sysUrl: localStorage.getItem(LOCAL_STORAGE_KEY_SYSURL),
    currentRow: null,
    currentPage: 1,
    departmentOptions: localStorage.getItem(LOCAL_STORAGE_DEPARTMENT_OPTIONS), // 监管部门类型
    searchForm: {
      ...SEARCHFORM
    },
    AdvancedForm: null, // 高级查询
    advancedSearch: false, // 高级查询是否展开
    checkCompany: '1',
    receivedNum: null
  },
  getters: {
    departmentOptions: (state) => {
      let departmentOptions = state.departmentOptions ? JSON.parse(state.departmentOptions) : []
      departmentOptions.splice(0, 1)
      return departmentOptions
    },
    roles: (state) => state.userInfo ? (state.userInfo.roles ? state.userInfo.roles : []) : [],
    controlId (state) {
      return Number(state.controlId)
    },
    sysUrl (state) {
      return JSON.parse(state.sysUrl)
    },
    needControlCompliance (state) {
      let id = Number(state.controlId)
      let data = [101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 121, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 201, 202, 206, 207, 208, 211]
      if (data.indexOf(id) != -1) {
        return true
      }
      return false
    },
    userInfo: (state) => state.userInfo,
    isSuperAdmin (state, getters) {
      if (getters.userInfo.town_id == 0 && getters.userInfo.department_id == 0) {
        return true
      } else {
        return false
      }
    },
    receivedNum: (state) => state.receivedNum
  },
  mutations: {
    [types.DEPARTMENTOPTIONS]: function (state, data) {
      state.departmentOptions = data
      localStorage.setItem(LOCAL_STORAGE_DEPARTMENT_OPTIONS, data)
    },
    [types.CURRENTROW]: function (state, data) {
      state.currentRow = data
    },
    [types.CURRENTPAGE]: function (state, data) {
      state.currentPage = data
    },
    [types.SEARCHFORM]: function (state, data) {
      state.searchForm = data
    },
    [types.ADVANCEFORM]: function (state, data) {
      state.AdvancedForm = data
    },
    [types.ADVANCEDSEARCH]: function (state, data) {
      state.advancedSearch = data
    },
    // 上次填报时间
    [types.EDITTIME]: function (state, data) {
      state.editTime = data
      localStorage.setItem(LOCAL_STORAGE_KEY_EDITTIME, data)
    },
    [types.RISKLEVEL]: function (state, data) {
      state.riskLevel = data
      localStorage.setItem(LOCAL_STORAGE_KEY_RISKLEVEL, data)
    },
    // 角色
    [types.ROLE]: function (state, data) {
      state.role = data
      localStorage.setItem(LOCAL_STORAGE_KEY_ROLE, data)
    },
    // 保存管控id
    [types.CONTROL_ID]: function (state, data) {
      state.controlId = data
      localStorage.setItem(LOCAL_STORAGE_KEY_CONTROL_ID, data)
    },
    // 保存企业id
    [types.COMPANY_ID]: function (state, data) {
      state.companyId = data
      localStorage.setItem(LOCAL_STORAGE_KEY_COMPANY_ID, data)
    },
    // 设置sessionId
    [types.SESSION_ID]: function (state, data) {
      state.sessionId = data
      localStorage.setItem(LOCAL_STORAGE_KEY_SESSION_ID, data)
    },
    // 设置用户信息
    'setUserInfo': function (state, data) {
      state.userInfo = data
    },
    // 登出，清除用户授权数据
    [types.LOGOUT]: function (state) {
      state.sessionId = null
      state.searchForm = {
        ...SEARCHFORM
      }
      state.userInfo = InitUserInfo
      localStorage.removeItem(LOCAL_STORAGE_KEY_SESSION_ID)
    },
    [types.PERMISSION_LIST]: function (state, data) {
      state.permissionList = data
      localStorage.setItem(LOCAL_STORAGE_KEY_PERMISSION_LIST, data)
    },
    // 跳转时需要的动态url
    [types.SYSURL]: function (state, data) {
      state.sysUrl = data
      localStorage.setItem(LOCAL_STORAGE_KEY_SYSURL, data)
    },
    // 系统配置-通知公告-已收通知-未阅读数
    'setreceivedNum': function (state, data) {
      state.receivedNum = data
    }
  },
  actions: {
    [types.GETSYSSETTINGS]: function(context) {
      http.post('/apps/setting/getSysSettings').then(res => {
        if (res.data.code == 0) {
          context.commit(types.SYSURL, JSON.stringify(res.data.data))
        } else {
          console.log(res.data.msg)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    async getUserInfo({ commit, state }) {
      commit('setUserInfo', null)
      const res = await http.post(api.getInfo)
      let userInfo = {}
      if (res.data.code == 0) {
        userInfo = {
          ...res.data.data, roles: ['ALL_ROUTERS']
        }
      }
      commit(types.SESSION_ID, userInfo.token)
      commit(types.ROLE, userInfo.role)
      commit(types.RISKLEVEL, 0)
      // commit(types.COMPANY_ID, null)
      let adminType = 1
      if (userInfo.department_id == 0 && userInfo.town_id == 0) { // 判断是否为超级管理员
        adminType = 0
      }
      commit(types.RESETPAGELIST, adminType) // 重置标签页
      commit('setUserInfo', userInfo)
    },
    // 行业监管部门
    async getBaseDepartmentTypeList ({ commit, state }) {
      const res = await http.post(api.getBaseDepartmentTypeList)
      if (res.data.code === 0) {
        commit(types.DEPARTMENTOPTIONS, JSON.stringify(res.data.data))
      }
    },
    async getReceivedNum({ commit, state }) {
      let receivedNum = null
      http.post('/apps/notice/getReceiveDepartmentNoticeList').then(res => {
        if (res.data.code == 0) {
          receivedNum = res.data.page_info.not_read_num
          commit('setreceivedNum', receivedNum)
        }
      })
    }
  },
  modules: {
    tab,
    permission
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js